module.exports = __webpack_public_path__ + "static/media/BALogo_Red-1.bcc0a0d2.png";